/**
 * login page
 * 2019-04-28 chenxiaojian
 */
import React from 'react';
// import ReactDOM from 'react-dom';
import {Button, Checkbox, Form, Icon, Input} from 'antd';
import {Toast} from 'antd-mobile';

import "../../style/common/login.css"

import http from '../../axios/http';
import messager from '../../component/ui/messager';

import Loading from '../ui/Loading';
import PasswordEncryptor from '../../util/PasswordEncryptor';
import VerifyCode from "./VerifyCode";
import VerifySlideFixed from "../captcha/verifySlideFixed";

// import Index from './Index';

class Login extends React.Component {

    state = {
        rememberMe: false,
        maskVisible: false,
        msgButtonEnable:false,
        msgError: false,
        msgTime: 59,

        verifyCode: '',
        showCode: false,
        codeType: '',
        param: {},
        isSlideShow: false
    }

    componentDidMount() {
        let rememberMe = localStorage.getItem("rememberMe");
        if (rememberMe === "true") {
            let username = localStorage.getItem("username");
            let password = localStorage.getItem("password");
            this.setState({ rememberMe: true, password: password, username: username });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            const username = values["username"];
            const password = values["password"];
            // const verifyCode = values["verifyCode"];
            const verifyCode = this.state.verifyCode;

            // const pwd = this.encrypt(username,password,verifyCode)
            const pwd = PasswordEncryptor.encryptPassword(password,username,verifyCode);
            let params = {
                username: username,
                password: pwd,
                verifyCode: verifyCode
            }

            if (!err) {
                this.setState({maskVisible: true});
                http.post({
                    url: '/login',
                    data: params,
                    success: (res) => {
                        this.setState({maskVisible: false});
                        //登录成功，设置登录状态
                        sessionStorage.setItem("loginStatus", "true");

                        localStorage.setItem("rememberMe",this.state.rememberMe);
                        localStorage.setItem("username", values["username"]);
                        localStorage.setItem("password", values["password"]);

                        window.location.href = "/";
                        //ReactDOM.render(<Index />, document.getElementById('root'));
                        let form=this.props.form
                        form.setFieldsValue({ "verifyCode": '' });
                    },
                    error: (res) => {
                        this.setState({maskVisible: false});
                        let form=this.props.form
                        form.setFieldsValue({ "verifyCode": '' });
                        messager.alert(res, "登录失败", "error");
                    }
                });
            }
        });
    }

    handleToVerify = e => {
        e.preventDefault();
        // this.props.form.validateFields((err, values) => {
        //     if (err) return;
        //     this.setState({
        //         codeType: 'sms',
        //         showCode: true,
        //         param: {
        //             username: values.username,
        //             password: values.password
        //         }
        //     });
        // });
        // return

        this.props.form.validateFields((err, values) => {
            if (err) return;
            http.post({
                url: '/user/getOTPByUsername',
                data: { username: values.username },
                success: res => {
                    this.setState({
                        codeType: res === 1 || res === '1' ? 'otp' : 'sms',
                        showCode: true,
                        param: {
                            username: values.username,
                            password: values.password
                        }
                    });
                }
            });
        });
    };

    doLogin = ({ username, password, verifyCode }) => {
        const pwd = PasswordEncryptor.encryptPassword(
            password,
            username,
            verifyCode
        );

        this.setState({ maskVisible: true });

        http.post({
            url: '/login',
            data: { username, password: pwd, verifyCode, isPc: '1' },
            success: () => {
                this.setState({ maskVisible: false });
                sessionStorage.setItem("loginStatus", "true");
                localStorage.setItem("rememberMe",this.state.rememberMe);
                localStorage.setItem("username", username);
                window.location.href = "/";
            },
            error: (res) => {
                this.setState({ maskVisible: false });
                messager.alert(res, "登录失败", "error");
            }
        });
    };

    sendMessage = () => {
        this.setState({maskVisible: true});
        let form=this.props.form
        if(form.getFieldValue("username")===null
        ||form.getFieldValue("username")===''
        ||form.getFieldValue("username")===undefined){
            messager.alert("请先输入用户名");
            this.setState({maskVisible: false});
            return
        }
        let username=form.getFieldValue("username")
        this.setState({msgButtonEnable: true});
        http.post({
            url: '/message/sendMessageForLogin',
            data: {
                userName:username
            },
            success: (res) => {
                this.setState({maskVisible: false});
                if(res.code!==200){
                    messager.alert(res.message);
                }else{
                    Toast.success('发送成功！');
                    this.count();
                }

            },
            error: (res) => {
                this.setState({maskVisible: false});
                messager.alert(res, "发送失败", "error");
                this.setState({msgError: true});
                this.msgButtonTimer = setTimeout(() => this.restoreMsgButton(), 3000);
            }
        });
    }

    restoreMsgButton=()=>{
        this.setState({msgError: false});
        this.setState({msgButtonEnable: false});
        clearInterval(this.msgButtonTimer);
    }

    count=() => {
        let { msgTime } = this.state;
        let siv = setInterval(() => {
            this.setState({ msgTime: msgTime -- },()=> {
                if(msgTime <=-1) {
                    clearInterval(siv);
                    this.setState({msgButtonEnable: false});
                    this.setState({ msgTime: 59 });
                }
            });
        }, 1000);
    }

    showVerifySlide = e => {
        this.props.form.validateFields((err, values) => {
            if (err) return;
            this.setState({
                isSlideShow: true
            });

        })

    }
    verifySlideFixedChild(data) {
        this.setState({
            isSlideShow: data
        })
    }
    success(data) {
        if (data) {
            this.props.form.validateFields((err, values) => {
                if (err) return;
                this.setState({
                    codeType: 'sms',
                    showCode: true,
                    param: {
                        username: values.username,
                        password: values.password
                    }
                });

            })
        }
        this.setState({
            isSlideShow: false
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return <div className="loginPage">
            <div className="login">
                <h2>二手车管理</h2>
                {/*<Form onSubmit={this.showVerifySlide}>*/}
                <Form>
                    <Form.Item  style={{ textAlign: 'right' }}>
                        {getFieldDecorator('username', {
                            rules: [{ required: true, message: '请输入用户名!' }],
                            initialValue: this.state.username
                        })(
                            <Input prefix={<Icon type="user" />} placeholder="用户名" />
                        )}
                    </Form.Item>
                    <Form.Item style={{ textAlign: 'right'}}>
                        {getFieldDecorator('password', {
                            rules: [{ required: true, message: '请输入密码!' }],
                            initialValue: this.state.password
                        })(
                            <Input prefix={<Icon type="lock" />} type="password" placeholder="密码" />
                        )}
                    </Form.Item>

                    {/*<Form.Item  style={{ textAlign: 'right',display: 'none' }}>*/}
                    {/*    {getFieldDecorator('verifyCode', {*/}
                    {/*        rules: [{ required: true, message: '请输入短信验证码!' }],*/}
                    {/*        initialValue: this.state.verifyCode*/}
                    {/*    })(*/}
                    {/*        <Input prefix={<Icon type="edit" />} placeholder="短信验证码" />*/}
                    {/*    )}*/}
                    {/*    <Button type="primary" disabled={this.state.msgButtonEnable} size='small' onClick={this.sendMessage} >*/}
                    {/*        {this.state.msgButtonEnable ? (this.state.msgError ? "发送短信验证码" : this.state.msgTime + 's后重新发送') : '发送短信验证码'}*/}
                    {/*    </Button>*/}
                    {/*</Form.Item>*/}

                    <Form.Item style={{ textAlign: 'right' }}>
                        <Checkbox checked={this.state.rememberMe} onChange={()=>{this.setState({rememberMe:!this.state.rememberMe})}}>记住我</Checkbox>
                        <Button type="primary" htmlType="submit" className="login-form-button" onClick={this.showVerifySlide}>
                            登录
                        </Button>
                    </Form.Item>
                </Form>
                <VerifyCode
                    type={this.state.codeType}
                    visible={this.state.showCode}
                    param={this.state.param}
                    onComplete={(code) => {
                        this.props.form.validateFields((err, values) => {
                            if (err) return;
                            this.setState({ showCode: false })
                            this.doLogin({
                                ...values,
                                verifyCode: code
                            });
                        });
                    }}
                    onCancel={() => this.setState({ showCode: false })}
                />
                {
                    this.state.isSlideShow ?
                        (<VerifySlideFixed isSlideShow={this.state.isSlideShow} verifyPointFixedChild={this.verifySlideFixedChild.bind(this)} success={this.success.bind(this)}/>)
                        : ''
                }
            </div>
            <Loading
                visible={this.state.maskVisible}
                message="登陆中"
            />

        </div>
    };
}

export default Form.create()(Login);
